import React from 'react'

const Footer = () => {
  return (
    <footer className="container-fluid py-4 d-print-none">
      <div className="row">
        <div className="col-sm">Christian Orengia Portfolio - 2023</div>
      </div>
    </footer>
  )
}

export default Footer